import type { FaireProductEntity } from "../../entity_types/product";

export const p_ktuszpngju: FaireProductEntity = {
  token: "p_ktuszpngju",
  type: "product",
  name: "Witch Pen",
  brandToken: "b_dfu92850",
  brandName: "Pippi Post",
  imageUrl:
    "https://cdn.faire.com/fastly/9a7b9fd4a20bc720d4406aa7fa3abada09d80b6cf8aff88263a1615bac225efb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c2ecc0709fed14cfe9236feb68d3b27cbe64f4198911a8c0362d4a8ac67c10eb.jpeg",
    "https://cdn.faire.com/fastly/1a559797796ea739f2bde2fe3c50f9da50ee5989014488951ce8e0ca03b545cd.jpeg",
  ],
  priceDollars: 2.76,
  description:
    "Unleash a bit of magical charm on your writing with the Witch Pen—a spellbinding writing tool designed for those who adore a touch of enchantment. Featuring a whimsical witch-inspired design, this pen adds a dash of fantasy and fun to your daily writing routine, making it an enchanting accessory for any desk.",
  tags: [],
  msrpDollars: 5.51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:12:00.910Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
